import { useState } from "react";

export default function useItem<T extends {id: number}> (data: Array<T>) {
    const [id, setId] = useState(-1);
    const item = (data || []).find(item => item.id === id);

    return {
        id, 
        setId,
        item
    }
}